import Axios from "axios";

let appConfig = {};

const loadConfig = async () => {
    let { data: config } = await Axios.get('/app-config.json');
    appConfig = config;

    return appConfig;
}

export { loadConfig, appConfig }


// WEBPACK FOOTER //
// ./src/app-config.js